import {useConfigToken} from '@/di/di.root-container.hooks';

import s from './Image.module.css';

type SrcSet = {
  avif: string;
  webp: string;
  [format: string]: string;
};

interface Props {
  id?: string;
  className?: string;
  alt: string;
  decoding?: 'async' | 'auto' | 'sync';
  onClick?(): void;
  src: string | SrcSet;
}

const addCDNUrl = (srcSet: string, cdnUrl: string): string => {
  return srcSet
    .split(', ')
    .map((srcSet) => `${cdnUrl}/${srcSet}`)
    .join(', ');
};

const getSrc = (srcSet: string, cdnUrl: string): string => {
  const srcs = srcSet.split(', ');

  return `${cdnUrl}/${srcs[srcs.length - 1].split(' ')[0]}`;
};

export const Image = ({id, decoding, src, className, alt, onClick}: Props): JSX.Element => {
  const cdnUrl = useConfigToken().cdnUrl;

  if (typeof src === 'object') {
    const {avif, webp, png, jpg, jpeg} = src;
    const otherFormatSrcSet = png || jpg || jpeg;

    return (
      <picture className={s.picture}>
        <source srcSet={addCDNUrl(avif, cdnUrl)} type={'image/avif'} />

        <source srcSet={addCDNUrl(webp, cdnUrl)} type={'image/webp'} />

        <img
          id={id}
          src={getSrc(otherFormatSrcSet, cdnUrl)}
          srcSet={addCDNUrl(otherFormatSrcSet, cdnUrl)}
          alt={alt}
          className={className}
          decoding={decoding}
          onClick={onClick}
        />
      </picture>
    );
  }

  return (
    <img
      id={id}
      src={src.startsWith('http') ? src : `${cdnUrl}/${src}`}
      alt={alt}
      className={className}
      decoding={decoding}
      onClick={onClick}
    />
  );
};
